import React, { useState, useEffect, useRef } from "react";
import "./secc_marcas.css";

/* Imágenes de marcas */
import marcah1 from "./img_marcas/insteon.png";
import marcah2 from "./img_marcas/fibaro.png";
import marcah3 from "./img_marcas/isde.png";
import marcah4 from "./img_marcas/lutron.png";
import marcah5 from "./img_marcas/honeywell.png";
import marcah6 from "./img_marcas/tuya.png";
import marcah7 from "./img_marcas/broadlink.png";
import marcah8 from "./img_marcas/zebra.png";
import marcah9 from "./img_marcas/viewsonic.png";
import marcah10 from "./img_marcas/cisco.png";
import marcah11 from "./img_marcas/fortinet.png";
import marcah12 from "./img_marcas/aruba.png";
import marcah13 from "./img_marcas/ruijie.png";
import marcah14 from "./img_marcas/ubiquiti.png";
import marcah15 from "./img_marcas/mikrotik.png";
import marcah16 from "./img_marcas/hikvision.png";
import marcah17 from "./img_marcas/zkteco.png";
import marcah18 from "./img_marcas/sat.png";
import marcah19 from "./img_marcas/lg.png";
import marcah20 from "./img_marcas/3nstar.png";
import marcah21 from "./img_marcas/ditec.png";
import marcah22 from "./img_marcas/roger.png";
import marcah23 from "./img_marcas/locher.png";
import marcah24 from "./img_marcas/seip.png";
import marcah25 from "./img_marcas/potter.png";
import marcah26 from "./img_marcas/gst.png";
import marcah27 from "./img_marcas/kidde.png";
import marcah28 from "./img_marcas/cofen.png";
import marcah29 from "./img_marcas/mircom.png";
import marcah30 from "./img_marcas/intelbras.png";
import marcah31 from "./img_marcas/dsc.png";
import marcah32 from "./img_marcas/risco.png";
import marcah33 from "./img_marcas/paradox.png";
import marcah34 from "./img_marcas/hagroy.png";
import marcah35 from "./img_marcas/linseng.png";
import marcah36 from "./img_marcas/panther.png";
import marcah37 from "./img_marcas/liftmaster.png";
import marcah38 from "./img_marcas/bft.png";
import marcah39 from "./img_marcas/cameditec.png";
import marcah40 from "./img_marcas/pilomat.png";
import marcah41 from "./img_marcas/tiesdi.png";
import marcah42 from "./img_marcas/anson.png";
import marcah43 from "./img_marcas/kaadas.png";
import marcah44 from "./img_marcas/lonbon.png";
import marcah45 from "./img_marcas/axis.png";
import marcah46 from "./img_marcas/hanwha.png";

const brands = [
  { name: "INSTEÓN", image: marcah1 },
  { name: "FIBARO", image: marcah2 },
  { name: "ISDE", image: marcah3 },
  { name: "LUTRON", image: marcah4 },
  { name: "HONEYWELL", image: marcah5 },
  { name: "TUYA", image: marcah6 },
  { name: "BROADLINK", image: marcah7 },
  { name: "ZEBRA", image: marcah8 },
  { name: "VIEWSONIC", image: marcah9 },
  { name: "CISCO", image: marcah10 },
  { name: "FORTINET", image: marcah11 },
  { name: "ARUBA", image: marcah12 },
  { name: "RUJIIE-REYEE", image: marcah13 },
  { name: "UBIQUITI", image: marcah14 },
  { name: "MICROTIK", image: marcah15 },
  { name: "HIKVISION", image: marcah16 },
  { name: "ZKTECO", image: marcah17 },
  { name: "SAT", image: marcah18 },
  { name: "LG", image: marcah19 },
  { name: "3NSTAR", image: marcah20 },
  { name: "DITEC", image: marcah21 },
  { name: "ROGER", image: marcah22 },
  { name: "LOCHER", image: marcah23 },
  { name: "SEIP", image: marcah24 },
  { name: "POTTER", image: marcah25 },
  { name: "GST", image: marcah26 },
  { name: "KIDDE", image: marcah27 },
  { name: "COFEN", image: marcah28 },
  { name: "MIRCOM", image: marcah29 },
  { name: "INTELBRAS", image: marcah30 },
  { name: "DSC", image: marcah31 },
  { name: "RISCO", image: marcah32 },
  { name: "PARADOX", image: marcah33 },
  { name: "HAGROY", image: marcah34 },
  { name: "LINSENG", image: marcah35 },
  { name: "PANTHER", image: marcah36 },
  { name: "LIFTMASTER", image: marcah37 },
  { name: "BFT", image: marcah38 },
  { name: "CAMEDITEC", image: marcah39 },
  { name: "PILOMAT", image: marcah40 },
  { name: "TIESDI", image: marcah41 },
  { name: "ANSON", image: marcah42 },
  { name: "KAADAS", image: marcah43 },
  { name: "LONBON", image: marcah44 },
  { name: "AXIS", image: marcah45 },
  { name: "HANWHA", image: marcah46 }
];

const BrandSlider = () => {
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const animationRef = useRef(null);
  const positionRef = useRef(0);
  const speedRef = useRef(1); // Velocidad de desplazamiento (píxeles por frame)

  // Animación suave con requestAnimationFrame
  const animate = () => {
    if (!isPaused && trackRef.current) {
      positionRef.current -= speedRef.current;
      
      // Calcular el ancho total de una copia de las marcas
      const itemWidth = trackRef.current.scrollWidth / 2; // Porque tenemos 2 copias
      
      // Reiniciar posición cuando se completa un ciclo
      if (-positionRef.current >= itemWidth) {
        positionRef.current += itemWidth;
      }
      
      trackRef.current.style.transform = `translateX(${positionRef.current}px)`;
    }
    
    animationRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    // Iniciar animación
    animationRef.current = requestAnimationFrame(animate);
    
    // Ajustar velocidad según el tamaño de pantalla
    const handleResize = () => {
      if (window.innerWidth < 468) {
        speedRef.current = 0.7;
      } else if (window.innerWidth < 992) {
        speedRef.current = 0.9;
      } else {
        speedRef.current = 1;
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    
    // Pausar/reanudar con hover
    const container = containerRef.current;
    if (!container) return;
    
    const handleMouseEnter = () => setIsPaused(true);
    const handleMouseLeave = () => setIsPaused(false);
    
    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);
    
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      window.removeEventListener('resize', handleResize);
      container.removeEventListener('mouseenter', handleMouseEnter);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isPaused]);

  return (
    <div className="expanded-container">
      <section className="brand-slider">
        <h2 className="brand-title">Las mejores marcas nos respaldan</h2>
        
        <div className="brand-carousel-container" ref={containerRef}>
          <div 
            ref={trackRef}
            className="brand-carousel-track"
          >
            {/* Duplicamos las marcas para el efecto infinito continuo */}
            {[...brands, ...brands].map((brand, idx) => (
              <div key={idx} className="brand-carousel-item">
                <div className="logo-container">
                  <img 
                    src={brand.image} 
                    alt={brand.name}
                    className="brand-logo"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
          
          {/* Superposición para efecto de desvanecimiento */}
          <div className="fade-overlay left"></div>
          <div className="fade-overlay right"></div>
        </div>
      </section>
    </div>
  );
};

export default BrandSlider;